import { projects } from '../../data/portfolio'
import { caseStudies } from '../../data/caseStudies'

/** In-scene project panel (3D hub) */
export const getProjectPath = (projectId) => `/projects/${projectId}`

/** Full flat case-study page */
export const getProjectDetailsPath = (projectId) => `/projects/${projectId}/details`

export const getProjectById = (projectId) => {
  const project = projects.find((item) => item.id === projectId)
  if (!project) return null

  return {
    ...project,
    ...caseStudies[projectId],
  }
}

export const getAdjacentProjects = (projectId) => {
  const index = projects.findIndex((item) => item.id === projectId)
  if (index === -1) return { previous: null, next: null }

  return {
    previous: index > 0 ? projects[index - 1] : null,
    next: index < projects.length - 1 ? projects[index + 1] : null,
  }
}
